import { NewWorkflowDrawer } from '@/pages/new-workflow-drawer';

export function CreateWorkflowPage() {
  return <NewWorkflowDrawer mode="create" />;
}
